export default __webpack_public_path__ + "static/media/service-3.8ad0e05c.jpg";